import type { JsonValue } from 'type-fest';

/**
 * We could have a message inside the error data object. Here we return
 * the first string from the first object value, otherwise we return
 * `null`.
 *
 * @example
 * const data1 = { value1: 'message', value2: ['yolo'] };
 * extractMessage(data1); // 'message'
 *
 * const data2 = { value1: ['message', 'oi'], value2: ['yolo'] };
 * extractMessage(data2); // 'message'
 *
 * const data3 = { value1: [42, 'oi'], value2: ['yolo'] };
 * extractMessage(data3); // null
 */
export function extractMessage(
  errorData: JsonValue | undefined,
): string | null {
  const firstError =
    errorData != null && typeof errorData === 'object'
      ? Object.values(errorData)[0]
      : null;
  const maybeMessage = Array.isArray(firstError) ? firstError[0] : firstError;
  return typeof maybeMessage === 'string' ? maybeMessage : null;
}
